import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { tokens } from '@redbax/shared';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

interface HorizontalBarProps {
  data: Array<{ name: string; value: number }>;
  title?: string;
  loading?: boolean;
}

export function HorizontalBar({ data, title = 'Top Services', loading }: HorizontalBarProps) {
  if (loading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="text-base">{title}</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="h-[300px] animate-pulse rounded bg-surface-raised" />
        </CardContent>
      </Card>
    );
  }

  if (data.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="text-base">{title}</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex h-[300px] items-center justify-center text-sm text-text-secondary">
            No service data available
          </div>
        </CardContent>
      </Card>
    );
  }

  const barHeight = 36;
  const chartHeight = Math.max(data.length * barHeight + 40, 120);

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div style={{ height: chartHeight }}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} layout="vertical" barCategoryGap="20%">
              <XAxis
                type="number"
                stroke={tokens.colors.textSecondary}
                fontSize={11}
                allowDecimals={false}
              />
              <YAxis
                type="category"
                dataKey="name"
                stroke={tokens.colors.textSecondary}
                fontSize={12}
                width={100}
                tickLine={false}
              />
              <Tooltip
                contentStyle={{
                  backgroundColor: tokens.colors.surface,
                  border: `1px solid ${tokens.colors.border}`,
                  borderRadius: '6px',
                  color: tokens.colors.textPrimary,
                  fontSize: 13,
                }}
                formatter={(value: number) => [value.toLocaleString(), 'Events']}
              />
              <Bar
                dataKey="value"
                fill={tokens.colors.redAccent}
                radius={[0, 4, 4, 0]}
                maxBarSize={24}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
}
